<template>
  <div class="confirm">
    <div class="confirm__header">Your password has been changed</div>
    <b-button variant="primary" class="w-100" @click="hideModal"> OK </b-button>
  </div>
</template>

<script>
export default {
  methods: {
    hideModal() {
      this.$emit('passwordChanged');
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm {
  text-align: center;

  &__header {
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.3rem;
    font-size: 2.5rem;
    margin-bottom: 2rem;
  }

  &__content {
    margin-bottom: 3rem;
  }

  &__footer {
    font-size: 0.9rem;
  }

  &__link {
    color: $blue;
    cursor: pointer;
  }
}
</style>
